import i18next from 'config/i18next';
import DateParser from 'utils/date/DateParser';
import DateFormatter from 'utils/date/DateFormatter';
import Personalizer from 'personalizer';
import ViewerUserPreferences from 'models/user/ViewerUserPreferences';
import LocaleMapper from 'utils/LocaleMapper';

const activityType = {
    walking: 'walking',
    running: 'running',
    cycling: 'cycling',
    swimming: 'swimming',
    steps: 'steps',
    steps_distance: 'steps_distance',
    calories: 'calories',
    pushes: 'pushes',
    para_sports: 'para_sports'
};

// Reference: picturePathTypes in GroupChallengeTypesMapper.js
export const ActivityTypeMap = {
    0: activityType.walking,
    1: activityType.running,
    2: activityType.cycling,
    3: activityType.swimming,
    4: activityType.steps,
    5: activityType.steps_distance,
    6: activityType.calories,
    10: activityType.pushes,
    11: activityType.para_sports
};

export const isTypeWalking = (activityTypeId) => ActivityTypeMap[activityTypeId] === activityType.walking;
export const isTypeRunning = (activityTypeId) => ActivityTypeMap[activityTypeId] === activityType.running;
export const isTypeCycling = (activityTypeId) => ActivityTypeMap[activityTypeId] === activityType.cycling;
export const isTypeSwimming = (activityTypeId) => ActivityTypeMap[activityTypeId] === activityType.swimming;
export const isTypeSteps = (activityTypeId) => ActivityTypeMap[activityTypeId] === activityType.steps;
export const isTypePushes = (activityTypeId) => ActivityTypeMap[activityTypeId] === activityType.pushes;
export const isTypeParaSports = (activityTypeId) => ActivityTypeMap[activityTypeId] === activityType.para_sports;

// Reference: formatValue in GroupChallengeLeaderboardView.js
export const formatTypeValue = (typeId, value) => {
    value = value || 0;

    if (isTypeSteps(typeId)) {
        return Personalizer.personalizeSteps(value);
    } else if (isTypeSwimming(typeId)) {
        const swimValue = Personalizer.personalizeSwimDistance(value);
        const swimUnit = i18next.t(`units:${Personalizer.getSwimDistanceUnitKey()}`);
        return `${swimValue} ${swimUnit}`;
    } else if (isTypeRunning(typeId) || isTypeCycling(typeId) || isTypeWalking(typeId) || isTypeParaSports(typeId)) {
        const distanceValue = Personalizer.personalizeDistancePrecision1(value);
        const distanceUnit = i18next.t(`units:${Personalizer.getDistanceUnitKey()}`);
        return `${distanceValue} ${distanceUnit}`;
    } else if (isTypePushes(typeId)) {
        return Personalizer.formatWholeNumber(value);
    } else {
        return value;
    }
};

// Reference: src/ChallengePage/constants.jsx
export const DURATION_TYPE = {
    ONE_DAY: 4,
    WEEKEND: 3,
    WEEK: 0,
    MONTH: 1,
    CUSTOM: 2
};

export const DURATION_TYPE_TO_IMAGE_KEY = {
    [DURATION_TYPE.ONE_DAY]: 'custom',
    [DURATION_TYPE.WEEKEND]: 'custom',
    [DURATION_TYPE.WEEK]: 'week',
    [DURATION_TYPE.MONTH]: 'month',
    [DURATION_TYPE.CUSTOM]: 'custom'
};

export const challengeStatus = {
    ready: 'ready',
    started: 'started',
    stopped: 'stopped',
    locked: 'locked',
    completed: 'completed',
    full: 'full'
};

export const getRankingMarkClass = (rank) => {
    switch (rank) {
        case 1:
            return 'colorGold';
        case 2:
            return 'colorSilver';
        case 3:
            return 'colorBronze';
        default:
            return '';
    }
};
